import React, { memo, useEffect, useState, useRef } from "react";
import AsyncSelect from "react-select/async";

const CodingBudgetLine = memo(({
    row,
    serverBudgetLineId,
    applyBudgetLineToItem,
    summaryDone,
    isNextFocus,
    budgetLines,
    loadBudgetLinesOptionsPerRow,
    searchBudgetLinesOptionsPerRow
}) => {
    const invoiceItemId = row.invoice_item_id;
    const [value, setValue] = useState(null);
    const lastServerValue = useRef(serverBudgetLineId);
    const selectRef = useRef(null);

    /* useEffect(() => {
        if (
            isNextFocus &&
            selectRef.current &&
            row.cost_code_id && row.cost_code_id!==''
        ) {
            selectRef.current.focus();
            selectRef.current.onMenuOpen?.();
        }


    }, [isNextFocus]); */

    useEffect(() => {

        if (!serverBudgetLineId || !budgetLines?.length) {
            setValue(null);
            lastServerValue.current = serverBudgetLineId;
            return;
        }
        //protection against serever value if we are in the middle of updating it ourselves
        if (serverBudgetLineId === lastServerValue.current && value) return;

        //if empty, set it so
        if (!serverBudgetLineId || serverBudgetLineId == '') {
            setValue(null);
            return;
        }

        const matched = budgetLines.find(b => b.b_dbid == serverBudgetLineId);
        setValue({
            value: matched.b_dbid,
            label: matched.budget_line,
        });

        lastServerValue.current = serverBudgetLineId;
    }, [serverBudgetLineId, budgetLines]);

    const handleChange = (option) => {
        applyBudgetLineToItem(
            invoiceItemId,
            option?.value || null
        );
    };

    const removeBudgetLine = () => {
        applyBudgetLineToItem(
            invoiceItemId,
            ''
        );
    };

    if (!summaryDone) {
        return (
            <div className="flex items-center gap-1">
                {value ? <span className="text-gray-600 text-l cursor-pointer w-6 h-6 text-center  leading-4.5 rounded-[50%] hover:text-orange-700 hover:underline" onClick={removeBudgetLine} href="#">x</span> : <span className="pl-[24px]"></span>}
                <div className="w-[100%]">
                    <AsyncSelect
                        ref={selectRef}
                        cacheOptions
                        defaultOptions={loadBudgetLinesOptionsPerRow(row.cost_code_id)}
                        loadOptions={searchBudgetLinesOptionsPerRow(row.cost_code_id)}
                        value={value}
                        onChange={handleChange}
                        placeholder="Select a Budget Line..."
                        noOptionsMessage={({ inputValue }) =>
                            inputValue ? "No results found" : "Type a budget line to search"
                        }
                    />
                </div>

            </div>

        );
    }

    return <span>{value?.label}</span>;
});

export default CodingBudgetLine;
